module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "fig",
    attrs: {
      "id": "c1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg9_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cht1"
  }, [_c('span', {
    staticClass: "e01"
  }, [_c('b', [_c('i', [_vm._v("County Fair")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indentc"
  }, [_c('i', [_vm._v("Is there such a thing as too many Churn Dash quilts? No way! This tried-and-true block has been loved by generations of quiltmakers for good reason—it’s versatile, full of humble charm, and a snap to piece. Set these sweet blocks among simple hourglass units, or tweak the cream and dark positions slightly, and one basic block suddenly takes on two distinctly different looks.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "e01"
  }, [_c('b', [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATERIALS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Yardage is based on a 42˝ width of useable fabric after prewashing and removing selvages.")])]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_c('span', {
    staticClass: "e01_nn"
  }, [_vm._v("•")]), _vm._v(" 1 fat quarter (18˝ × 21˝) of black print for patchwork and binding")]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_c('span', {
    staticClass: "e01_nn"
  }, [_vm._v("•")]), _vm._v(" 24 chubby sixteenths (9˝ × 10½˝) of assorted prints for patchwork")]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_c('span', {
    staticClass: "e01_nn"
  }, [_vm._v("•")]), _vm._v(" 5 skinny eighths (4½˝ × 21˝) of assorted cream prints for patchwork")]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_c('span', {
    staticClass: "e01_nn"
  }, [_vm._v("•")]), _vm._v(" ½ yard of fabric for backing")]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_c('span', {
    staticClass: "e01_nn"
  }, [_vm._v("•")]), _vm._v(" 18˝ × 31˝ piece of batting")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "e01"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTTING")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Cut all pieces across the width of the fabric in the order given unless otherwise noted. For the Churn Dash A and B blocks, cutting is provided for one individual block to enable you to easily plan your print and color choices; simply repeat the cutting to produce the needed number of patchwork sets.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('b', [_vm._v("From the black print, cut:")])]), _vm._v(" "), _c('p', {
    staticClass: "indenth"
  }, [_vm._v("4 binding strips, 2½˝ × 21˝ (for my chubby binding method, reduce the strip width to 2˝)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reserve the remainder of the black print for the patchwork blocks.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_c('i', [_vm._v("Hourglass Blocks")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_vm._v("From "), _c('i', [_vm._v("each")]), _vm._v(" of 10 of the assorted chubby sixteenths, cut:")])]), _vm._v(" "), _c('p', {
    staticClass: "indenth"
  }, [_vm._v("1 square, 4¼˝ × 4¼˝ (combined total of 10); cut each square in half diagonally "), _c('i', [_vm._v("twice")]), _vm._v(" to yield 4 triangles (combined total of 40).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Keep the triangles organized into an Hourglass set; reserve the remainder of these assorted prints.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As your scraps permit after cutting all required pieces for this quilt, you may wish to cut a handful of additional squares and cut them into triangles for scrappier blocks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('b', [_vm._v("From "), _c('i', [_vm._v("each")]), _vm._v(" of the 5 assorted cream prints, cut:")])]), _vm._v(" "), _c('p', {
    staticClass: "indenth"
  }, [_vm._v("1 square, 4¼˝ × 4¼˝ (combined total of 5); cut each square in half diagonally "), _c('i', [_vm._v("twice")]), _vm._v(" to yield 4 triangles (combined total of 20).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Add the assorted cream triangles to the Hourglass set; reserve the remainder of the assorted cream prints for the Churn Dash blocks")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_c('i', [_vm._v("Churn Dash A Blocks")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_vm._v("From "), _c('i', [_vm._v("all")]), _vm._v(" assorted prints, including the remainder of the black and previously used prints, choose 4 prints per block. You’ll need 8 sets of 4 prints. From each set, cut:")])]), _vm._v(" "), _c('p', {
    staticClass: "indenth"
  }, [_vm._v("1 square, 1½˝ × 1½˝ (center square, from one print)")]), _vm._v(" "), _c('p', {
    staticClass: "indenth"
  }, [_vm._v("1 strip, 1˝ × 7˝ (side inner rectangles, from a second print)")]), _vm._v(" "), _c('p', {
    staticClass: "indenth"
  }, [_vm._v("1 strip, 1˝ × 7˝ (side outer rectangles, from a third print)")]), _vm._v(" "), _c('p', {
    staticClass: "indenth"
  }, [_vm._v("2 squares, 1⅞˝ × 1⅞˝; cut each square in half diagonally "), _c('i', [_vm._v("once")]), _vm._v(" to yield 2 triangles (total of 4; corner inner triangles, from the fourth print).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Keep the pieces organized into a Churn Dash A set.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Repeat to cut a total of 8 Churn Dash A sets.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_c('i', [_vm._v("Churn Dash B Blocks")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_vm._v("From the scraps of "), _c('i', [_vm._v("all")]), _vm._v(" assorted prints, choose 4 prints per block. You’ll need 3 sets of 4 prints. From each set, cut:")])]), _vm._v(" "), _c('p', {
    staticClass: "indenth"
  }, [_vm._v("1 square, 1½˝ × 1½˝ (center square, from one print)")]), _vm._v(" "), _c('p', {
    staticClass: "indenth"
  }, [_vm._v("1 strip, 1˝ × 7˝ (side inner rectangles, from a second print)")]), _vm._v(" "), _c('p', {
    staticClass: "indenth"
  }, [_vm._v("1 strip, 1˝ × 7˝ (side outer rectangles, from a third print)")]), _vm._v(" "), _c('p', {
    staticClass: "indenth"
  }, [_vm._v("2 squares, 1⅞˝ × 1⅞˝; cut each square in half diagonally "), _c('i', [_vm._v("once")]), _vm._v(" to yield 2 triangles (total of 4; corner inner triangles, from the fourth print).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Keep the pieces organized into a Churn Dash B set.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Repeat to cut a total of 3 Churn Dash B sets.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('b', [_vm._v("From the remainder of the assorted cream prints, cut a "), _c('i', [_vm._v("combined")]), _vm._v(" total of:")])]), _vm._v(" "), _c('p', {
    staticClass: "indenth"
  }, [_vm._v("6 squares, 1⅞˝ × 1⅞˝; cut each square in half diagonally "), _c('i', [_vm._v("once")]), _vm._v(" to yield 2 triangles (combined total of 12). Choosing the prints randomly, add 4 cream triangles to each Churn Dash B set.")]), _vm._v(" "), _c('p', {
    staticClass: "indenth"
  }, [_vm._v("40 squares, 2˝ × 2˝. Keep these squares organized into a flying-geese set.")]), _vm._v(" "), _c('p', {
    staticClass: "indenth"
  }, [_vm._v("4 additional squares, 2˝ × 2˝")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('b', [_vm._v("From the remaining scraps of all assorted prints, cut a "), _c('i', [_vm._v("combined")]), _vm._v(" total of:")])]), _vm._v(" "), _c('p', {
    staticClass: "indenth"
  }, [_vm._v("20 rectangles, 2˝ × 3½˝. Add these rectangles to the flying-geese set.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "e01"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IECING THE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURGLASS")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOCKS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Sew all pieces with right sides together using a ¼˝ seam allowance unless otherwise noted. Press the seam allowances as indicated by the arrows or otherwise specified.")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_c('span', {
    staticClass: "e01_f"
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" From the Hourglass Block set, randomly select two print triangles and two cream triangles. Lay out the triangles in two diagonal rows as shown, above right. Join the triangles in each row. Press. Join the rows. Press.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_c('span', {
    staticClass: "e01_f"
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Repeat to piece 10 scrappy Hourglass blocks measuring 3½˝ square, including the seam allowances.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Please note that you’ll have a handful of unused assorted print triangles; these have been included for added choices as you piece the patchwork.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg10_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "e01"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IECING THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURN")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASH")]), _vm._v(" A B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOCKS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_c('span', {
    staticClass: "e01_f"
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Select one Churn Dash A set. Join the two assorted print 1˝ × 7˝ strips along the long edges. Press. Crosscut the pieced strip at 1½˝ intervals to make four strip-set segments measuring 1½˝ square, including the seam allowances.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg10_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_c('span', {
    staticClass: "e01_f"
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Choose the 1⅞˝ triangles cut from two assorted prints. Layer two triangles, one from each print, together. Join the pair along the long diagonal edges. Press. Trim away the dog-ear points. Repeat to piece four matching half-square-triangle units measuring 1½˝ square, including the seam allowances.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg10_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_c('span', {
    staticClass: "e01_f"
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Lay out the four half-square-triangle units, the four strip-set segments, and the 1½˝ center square in three horizontal rows. Join the pieces in rows and then join the rows. Press. The pieced Churn Dash A block should measure 3½˝ square, including the seam allowances.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_c('span', {
    staticClass: "e01_f"
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Repeat steps 1–4 to piece a total of eight Churn Dash A blocks.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg10_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg11_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1a"
  }, [_c('span', {
    staticClass: "e01"
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INISHED QUILT SIZE")]), _vm._v(": 12½˝ × 24½˝ • F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INISHED BLOCK SIZE")]), _vm._v(": 3˝ × 3˝")])])]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_c('i', [_vm._v("Designed and pieced by Kim Diehl. Machine quilted by Connie Tabor.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "e01"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IECING THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURN")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASH")]), _vm._v(" B B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOCKS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Using the Churn Dash B sets, repeat steps 1–4 of “Piecing the Churn Dash A Blocks” to piece a total of three Churn Dash B blocks that have cream triangle corners. The blocks should measure 3½˝ square, including the seam allowances.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg12_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "e01"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IECING THE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LYING-")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EESE")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NITS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_c('span', {
    staticClass: "e01_f"
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Use a pencil and an acrylic ruler to draw a diagonal sewing line from corner to corner on the wrong side of each of the 40 cream 2˝ squares.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_c('span', {
    staticClass: "e01_f"
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Choose a 2˝ × 3½˝ print rectangle from the flying-geese set. Layer a prepared cream square onto one end of the rectangle. Stitch the pair along the drawn line. Fold the resulting inner triangle open. Press. Trim away the layers beneath the top triangle, leaving a ¼˝ seam allowance. In the same manner, add a mirror-image triangle to the remaining end of the rectangle. The pieced flying-geese unit should measure 2˝ × 3½˝, including the seam allowances.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_c('span', {
    staticClass: "e01_f"
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Repeat steps 1 and 2 to piece a total of 20 flying-geese units.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg12_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg12_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "e01"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IECING THE")]), _vm._v(" Q"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UILT")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OP")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_c('span', {
    staticClass: "e01_f"
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Lay out two Churn Dash A blocks and one Hourglass block in alternating positions. Join the blocks. Press. Repeat to piece a total of four Churn Dash A rows measuring 3½˝ × 9½˝, including the seam allowances.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg12_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_c('span', {
    staticClass: "e01_f"
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Lay out two Hourglass blocks and one Churn Dash B block in alternating positions. Join the blocks. Press. Repeat to piece a total of three Hourglass rows measuring 3½˝ × 9½˝, including the seam allowances.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg12_5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_c('span', {
    staticClass: "e01_f"
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Refer to the quilt center assembly diagram to lay out the Churn Dash rows and the Hourglass rows in alternating positions. Join the rows. Press. The pieced quilt enter should measure 9½˝ × 21½˝, including the seam allowances.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg12_6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_c('span', {
    staticClass: "e01_f"
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Join seven flying-geese units end to end. Press. Repeat to piece two long flying-geese border strips measuring 2˝ × 21½˝, including the seam allowances.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg12_7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_c('span', {
    staticClass: "e01_f"
  }, [_c('b', [_vm._v("5.")])]), _vm._v(" Join three flying-geese units end to end. Press. Join a cream 2˝ square to each end of the pieced strip. Press. Repeat to piece a two short flying-geese border strips measuring 2˝ × 12½˝, including the seam allowances.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg13_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_c('span', {
    staticClass: "e01_f"
  }, [_c('b', [_vm._v("6.")])]), _vm._v(" Join the long border strips to the right and left sides of the quilt center. Press. Join the short border strips to the remaining ends of the quilt top. Press. Use a rotary cutter and an acrylic ruler to trim away the outer cream triangle portion of each corner square, leaving a ¼˝ seam allowance.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg13_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "e01"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMPLETING THE")]), _vm._v(" Q"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UILT")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Layer and baste the quilt top, batting, and backing. Quilt the layers. The featured quilt is machine quilted with an edge-to-edge chicken wire design. Join the black binding strips to make one length and use it to bind the quilt..")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg13_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg14_1.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ccd2d16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_chapter01.vue
// module id = 66
// module chunks = 0